/* eslint-disable complexity */
import { Pickable } from '@app/engine/core/interfaces';
import { html } from '@app/engine/utils/development/formatter';
import { SpaceObjectType } from '@ootk/src/main';
import { ColorScheme } from './color-scheme';
export class SmallSatColorScheme extends ColorScheme {
    label = 'Small Satellites';
    id = 'SmallSatColorScheme';
    static id = 'SmallSatColorScheme';
    isOptionInRmbMenu = false;
    static uniqueObjectTypeFlags = {
        satSmall: true,
    };
    static uniqueColorTheme = {
        satSmall: [0.0, 0.0, 1.0, 1.0],
    };
    constructor() {
        super(SmallSatColorScheme.uniqueColorTheme);
        this.objectTypeFlags = {
            ...this.objectTypeFlags, ...SmallSatColorScheme.uniqueObjectTypeFlags,
        };
    }
    update(obj) {
        if (!obj.isSatellite()) {
            return { color: this.colorTheme.transparent, pickable: Pickable.No };
        }
        const sat = obj;
        // Check if it is a small payload
        if (sat.rcs && sat.rcs < 0.5 && sat.type === SpaceObjectType.PAYLOAD) {
            if (!this.objectTypeFlags.satSmall) {
                return {
                    color: this.colorTheme.deselected,
                    pickable: Pickable.No,
                };
            }
            return {
                color: this.colorTheme.satSmall,
                pickable: Pickable.Yes,
            };
        }
        return {
            color: this.colorTheme.transparent,
            pickable: Pickable.No,
        };
    }
    static layersHtml = html `
  <ul id="layers-list-small">
    <li>
      <div class="Square-Box layers-satSmall-box"></div>
      Small Satellite
    </li>
  </ul>
  `.trim();
}
